export default "__VITE_ASSET__T$QAlQIK__"